import { API_CONFIG, apiUtils } from '../config';

const subjectApi = {
  // 1. Create Subject
  createSubject: async (subjectData) => {
    const url = `${API_CONFIG.BASE_URL}/subject/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(subjectData),
    });
  },

  // 2. Get All Subjects (with Filters)
  getAllSubjects: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/subject/all?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // 3. Get Subjects by Class
  getSubjectsByClass: async (unitId, academicYear) => {
    let url = `${API_CONFIG.BASE_URL}/subject/class/${unitId}`;
    if (academicYear) {
      url += `?academicYear=${academicYear}`;
    }
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // 4. Get Subject Codes by Class (Lightweight)
  getSubjectCodesForClass: async (unitId, academicYear) => {
    let url = `${API_CONFIG.BASE_URL}/subject/codes/class/${unitId}`;
    if (academicYear) {
      url += `?academicYear=${academicYear}`;
    }
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // 5. Get Single Subject
  getSubjectById: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/subject/${id}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // 6. Update Subject
  updateSubject: async (id, subjectData) => {
    const url = `${API_CONFIG.BASE_URL}/subject/${id}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(subjectData),
    });
  },

  // 7. Delete Subject
  deleteSubject: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/subject/${id}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'DELETE',
    });
  },

  // 8. Bulk Create Subjects
  bulkCreateSubjects: async (subjectsData) => {
    const url = `${API_CONFIG.BASE_URL}/subject/bulk-create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(subjectsData),
    });
  }
};

export default subjectApi;
